import { BedDouble, Heart, MapPin, Maximize2, MoveRight } from "lucide-react";
import { Link } from "react-router-dom";

const formatter = new Intl.NumberFormat("fr-FR");

export default function PropertyCard({ property, onFavorite, isFavorite }) {
  return (
    <article className="property-card" data-testid={`property-card-${property.id}`}>
      <Link to={`/biens/${property.id}`} className="property-image-wrap" data-testid={`property-image-link-${property.id}`}>
        <img
          src={property.image}
          alt={property.title}
          className="property-image"
          loading="lazy"
          decoding="async"
        />
        {property.exclusive && <span className="exclusive-badge" data-testid={`exclusive-badge-${property.id}`}>Exclusivité</span>}
        <span className="dpe-badge" data-testid={`dpe-badge-${property.id}`}>DPE {property.dpe}</span>
      </Link>
      <button
        className={`favorite-button ${isFavorite ? "is-active" : ""}`}
        data-testid={`favorite-property-${property.id}`}
        onClick={() => onFavorite(property)}
        aria-label={`Ajouter ${property.title} aux favoris`}
      >
        <Heart size={18} fill={isFavorite ? "currentColor" : "none"} />
      </button>
      <div className="property-content">
        <p className="property-location"><MapPin size={14} /> {property.city} · {property.postal_code}</p>
        <Link to={`/biens/${property.id}`} className="property-title" data-testid={`property-title-link-${property.id}`}>{property.title}</Link>
        <div className="property-specs" data-testid={`property-specs-${property.id}`}>
          <span><Maximize2 size={15} /> {property.surface} m²</span>
          <span><BedDouble size={16} /> {property.rooms} pièces</span>
        </div>
        <div className="property-bottom">
          <p className="property-price" data-testid={`property-price-${property.id}`}>{formatter.format(property.price)} €</p>
          <Link to={`/biens/${property.id}`} className="arrow-link" data-testid={`property-detail-link-${property.id}`} aria-label={`Découvrir ${property.title}`}>
            <MoveRight size={20} />
          </Link>
        </div>
      </div>
    </article>
  );
}